import {
  MISSATGE_NO_CONEXIO_SERVIDOR,
  MISSATGE_SESSIO_CADUCADA
} from "../constantsFormularis";
export const mostrarMissatgeError = dades => {
  if (dades.error && dades.error === "Error: Network Error") {
    return {
      error: dades.error,
      missatge: MISSATGE_NO_CONEXIO_SERVIDOR
    };
  }
  if (dades.error && dades.error.status && dades.error.status === 401) {
    return {
      error: dades.error,
      missatge: MISSATGE_SESSIO_CADUCADA
    };
  }
  if (
    (dades.error && dades.error.message && dades.error.titol) ||
    (dades.message && dades.titol)
  ) {
    return {
      error: dades.error && dades.error.titol ? dades.error.titol : dades.titol,
      missatge:
        dades.error && dades.error.message ? dades.error.message : dades.message
    };
  }
  return null;
};
